import React from 'react';

import { FieldProps, getIn } from 'formik';

import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FormGroup from './FormGroup';
import Input from './Input';

type Props = React.ComponentProps<typeof Input> &
    FieldProps<any> & {
        required?: boolean;
        name: string;
        value: string;
        onChange: (ev: any) => void;
        autoFocus?: boolean;
        mapNameToLabel?: (name: string) => string;
    };

// @todo Switch to using FormInput inside FormikInput
const FormikInput: React.FC<Props> = React.forwardRef(
    ({ field = {}, form = {}, mapNameToLabel = (i) => i, ...props }, ref) => {
        const name = field.name || props.name;
        const error = getIn(form.errors, name);
        const touched = getIn(form.touched, name);
        const showError = (touched || form.submitCount > 0) && !!error;

        const status = showError
            ? 'error'
            : // form.touched[field.name] ? 'success' :
              undefined;

        // Mark field as touched on every change for instant validation
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (typeof (form as any).setFieldTouched === 'function') {
                (form as any).setFieldTouched(name, true, false);
            }
            if (typeof (field as any).onChange === 'function') {
                (field as any).onChange(e);
            } else if (typeof (props as any).onChange === 'function') {
                (props as any).onChange(e);
            }
        };

        return (
            <FormGroup itemsSpacing={5}>
                <FieldLabel>
                    {mapNameToLabel(name)} {props.required && '*'}
                </FieldLabel>
                <Input
                    ref={ref}
                    style={{ fontSize: '1.6rem' }}
                    placeholder={mapNameToLabel(name)}
                    status={status}
                    error={showError}
                    {...field}
                    {...props}
                    onChange={handleChange}
                />
                <FieldStatusText status="error">{showError ? error : undefined}</FieldStatusText>
            </FormGroup>
        );
    }
);

export default FormikInput;
